<ng-container>

  <ng-template #loginHelp>

    <div class="login-help-header">
      <app-h3>Unity Login</app-h3>
      <div class="login-help-header__actions">
        <ng-container *ngIf="{ isDark: (theme.isDark$ | async) ?? false } as vm">
          <button
            type="button"
            class="login-help-header__theme-toggle"
            tid="login-theme-toggle"
            (click)="toggleDarkMode()"
            [attr.aria-label]="vm.isDark ? 'Switch to light mode' : 'Switch to dark mode'"
            [attr.aria-pressed]="vm.isDark"
          >
            <app-icon [size]="'small'" [color]="vm.isDark ? 'white' : 'primary-action'">{{
              vm.isDark ? 'light_mode' : 'dark_mode'
            }}</app-icon>
          </button>
          <app-button
            class="login-help-header__help"
            icon="contact_support"
            (click)="openContactForm()"
            [iconColor]="vm.isDark ? 'white' : 'primary-action'"
            [iconHoverColor]="vm.isDark ? 'white' : 'primary-action'"
            theme="ink-02"
            [uppercaseText]="false"
            tid="help-button"
          >Help</app-button>
        </ng-container>
      </div>
    </div>

  </ng-template>

  <ng-container >
    <ng-template [ngTemplateOutlet]="loginHelp"></ng-template>

    <form
        tid="login-form"
        *ngIf="signInFormGroup"
        [formGroup]="signInFormGroup"
        (ngSubmit)="signIn()"
      >
      <app-input
        tid="email-address"
        [type]="'email'"
        [emailField]="true"
        formPropertyName="username"
        label="Email"
        placeholder="Enter your login email"
        [requiredField]="true"
      ></app-input>

      <app-password-input
        class="mt-3 d-block"
        label="Password"
        tid="password"
        formPropertyName="password"
        placeholder="Enter your password"
        [requiredField]="true"
      ></app-password-input>

      <div class="remember-row mt-3 mb-2">
        <app-checkbox
          class="remember-row__checkbox"
          tid="remember-me-checkbox"
          label="Remember me"
          formPropertyName="rememberMe"
        ></app-checkbox>
        <app-a
          class="remember-row__forgot forgot-password-button"
          (click)="openForgotPassword()"
          tid="forgot-password-button"
        >Forgotten your password?</app-a>
      </div>

      <mat-error
        class="mb-2"
        tid="login-error"
        *ngIf="errorMessage !== ''" 
       >{{errorMessage}}
      </mat-error>

      <div class="footer-actions mb-4">
        <app-button
          class="footer-actions__login"
          theme="primary-action"
          type="submit"
          [fullWidth]="true"
          [loading]="fetching$ | async"
          tid="login-button"
        >Log in</app-button>
      </div>

      <div class="mt-3 mb-4 d-block" *ngIf="showMicrosoftLogin()">
        <app-microsoft-login
          tid="microsoft-login"
        ></app-microsoft-login>
      </div>

    </form>
  </ng-container>

</ng-container>
